//TODO: data related to each author on the blog posts should be added incrementally here.

module.exports = [
  {
    name: "Joel Coutinho",
    jobTitle: "Software Developer at SuperTokens",
    image: "joel.png",
    socials: [
      {
        name: "github",
        url: "https://github.com/jscyo",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/joel-coutinho-7bbb89143",
      },
    ],
    bio: "Software dev and content lead at SuperTokens. Contributed to the SuperTokens core, backend SDKs, and developer documentation.",
  },
  {
    name: "Michiel Mulders",
    jobTitle: "Web3 Developer Advocate",
    image: "michel.jpg",
    socials: [
      {
        name: "twitter",
        url: "https://twitter.com/michiel_mulders",
      },
    ],
    bio: "Michiel Mulders is a Web3 developer advocate skilled in creating engaging tech tutorials. He specializes in documentation strategy and video content.",
  },
  {
    name: "Rishabh Poddar",
    jobTitle: "Ex-CTO at SuperTokens",
    image: "rishabh.jpg",
    socials: [
      {
        name: "twitter",
        url: "https://twitter.com/rishpoddar",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/rishabh-poddar-b64b73129/",
      },
      {
        name: "github",
        url: "https://github.com/rishabhpoddar",
      },
    ],
    bio: "Cofounder and CTO of SuperTokens. Building open source user authentication that is quick and customizable. BEng from Imperial College of London",
  },
  {
    name: "Mostafa Ibrahim",
    jobTitle: "Senior Software Engineer",
    image: "mostafa.jpg",
    socials: [
      {
        name: "twitter",
        url: "https://twitter.com/mostafa41490059?",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/mostafa-ibrahim-948004151/",
      },
    ],
    bio: "Senior software engineer at a Fintech in London. Passionate about content creation, AI and traveling.",
  },
  {
    name: "Advait Ruia",
    jobTitle: "Co-Founder and CEO at SuperTokens",
    image: "advait.jpg",
    socials: [
      {
        name: "twitter",
        url: "https://twitter.com/Advait_Ruia",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/advait-ruia-2aa52a85/",
      },
    ],
    bio: "Cofounder and CEO of SuperTokens. Building open source user authentication that is quick and customizable. BEng from Imperial College of London",
  },
  {
    name: "Sarah Sanders",
    jobTitle: "Technical Writer",
    image: "sarah.jpg",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/sarah-s-42913121a/",
      },
    ],
    bio: "San Francisco-based technical writer dedicated to empowering developers with quality documentation, educational resources, and innovative learning tools.",
  },
  {
    name: "Darko Bozhinovski",
    jobTitle: " DevRel at SuperTokens",
    image: "darko.png",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/darkobozhinovski/",
      },
      {
        name: "twitter",
        url: "https://twitter.com/d_bozhinovski",
      },
      {
        name: "github",
        url: "https://github.com/DBozhinovski",
      },
    ],
    bio: "Developer, writer, speaker, and Linux nerd. Remembers IE6.",
  },
  {
    name: "Connor Peshek",
    jobTitle: " DevRel at SuperTokens",
    image: "connor.jpg",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/connor-peshek/",
      },
      {
        name: "twitter",
        url: "https://twitter.com/conzorkingkong",
      },
      {
        name: "github",
        url: "https://github.com/conzorkingkong",
      },
    ],
    bio: "Musician, horror movie lover, and total nerd.",
  },
  {
    name: "Joshua Omobola",
    jobTitle: "DevRel at SuperTokens",
    image: "joshua.png",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/kohasummons/",
      },
      {
        name: "twitter",
        url: "https://twitter.com/kohawithstuff",
      },
      {
        name: "github",
        url: "https://github.com/kohasummons",
      },
    ],
    bio: "Developer Advocate. Digital Designer. IndieHacker",
  },
  {
    name: "Maria Shimkovska",
    jobTitle: "Technical Writer",
    image: "maria.jpg",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/maria-shimkovska/",
      },
      {
        name: "github",
        url: "https://github.com/meems1996",
      },
    ],
    bio: "Technical Writer. Huge Reader. I love startups and open source.",
  },
  {
    name: "Dejan Lukić",
    jobTitle: "Full-stack developer, tehcnical writer & entrepreneur",
    image: "dejan.png",
    socials: [
      {
        name: "website",
        url: "https://lukicdejan.com/blog",
      },
      {
        name: "github",
        url: "https://github.com/lukiccd",
      },
    ],
    bio: "Experienced full-stack developer, technical writer, and electronics enthusiast turned generalist.",
  },
  {
    name: "Nemi Shah",
    jobTitle: "Senior iOS Engineer at Deltatre",
    image: "nemi.jpg",
    socials: [
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/nemi-shah/",
      },
      {
        name: "twitter",
        url: "https://x.com/NemiShah3",
      },
      {
        name: "github",
        url: "https://github.com/nkshah2",
      },
    ],
    bio: "Mobile engineer, Indie software dev, Gaming enthusiast, and a tea lover.",
  },
  {
    name: "Maurice Saldivar",
    jobTitle: "Technical Writer",
    image: "maurice.jpg",
    socials: [
      ,
      {
        name: "github",
        url: "https://github.com/msaldivar",
      },
    ],
    bio: "Audiobook fan, avid golfer, and no zero-days.",
  },
  {
    name: "Bogdan Carpusor",
    jobTitle: "Engineer at SuperTokens",
    image: "bogdan.png",
    socials: [
      {
        name: "github",
        url: "https://github.com/bcbogdan",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/bogdan-carpusor-4190865a",
      },
      {
        name: "twitter",
        url: "https://x.com/bcbogdan",
      },
    ],
    bio: "Engineer at SuperTokens. Building open source user authentication that is quick and customizable.",
  },
]
